import React from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../../AppContext';
import * as C from '../../components';
import * as F from '../../form';

import clsx from 'clsx';

export const NewT1 = ({
  onOK,
  onCancel,
}: {
  onOK: () => void;
  onCancel: () => void;
}) => {
  const appCtx = React.useContext(AppContext);
  const { t, i18n } = useTranslation();

  const formik = useFormik({
    isInitialValid: false,
    initialValues: {
      v1: '',
      v2: '',
      v3: '',
      v4: '',
      v5: '',
      v6: '',
    },
    validationSchema: Yup.object().shape({
      v1: Yup.string().required(t('Required')),
      v2: Yup.string().required(t('Required')),
      v3: Yup.string().required(t('Required')),
      v4: Yup.string().required(t('Required')),
      v5: Yup.string().required(t('Required')),
      v6: Yup.string().required(t('Required')),
    }),
    onSubmit: async (values) => {
      await appCtx.fetchApi2('post', '/api/v2/maintain/cfg', {
        rules: [
          {
            store_id: values.v1,
            store_name: values.v2,
            item: values.v3,
            period: Number(values.v4),
            dt_start: values.v5,
            note: values.v6,
          },
        ],
      });
      onOK();
    },
  });

  return (
    <div>
      <div className="text-white text-center py-1 bg-bar">{t('New')}</div>

      <div className="p-3">
        <F.Input
          label="店號"
          value={formik.values.v1}
          onValueChange={(value) => formik.setFieldValue('v1', value)}
        />
        <F.Input
          label="店名"
          value={formik.values.v2}
          onValueChange={(value) => formik.setFieldValue('v2', value)}
        />
        <F.Input
          label="保養品項"
          value={formik.values.v3}
          onValueChange={(value) => formik.setFieldValue('v3', value)}
        />
        <F.Input
          label="保養週期"
          value={formik.values.v4}
          onValueChange={(value) => formik.setFieldValue('v4', value)}
        />
        <F.Input
          label="起算日"
          value={formik.values.v5}
          onValueChange={(value) => formik.setFieldValue('v5', value)}
        />
        <F.Input
          label="備註"
          value={formik.values.v6}
          onValueChange={(value) => formik.setFieldValue('v6', value)}
        />

        <div className="mt-5 flex justify-end space-x-2">
          <button
            className="px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none"
            onClick={onCancel}
          >
            <div className="text-white text-base">{t('Cancel')}</div>
          </button>
          <button
            className={clsx(
              'px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none',
            )}
            onClick={() => formik.submitForm()}
          >
            <div className="text-white text-base">{t('Confirm')}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export const EditT1 = ({
  item,
  onOK,
  onCancel,
}: {
  item: any;
  onOK: () => void;
  onCancel: () => void;
}) => {
  const appCtx = React.useContext(AppContext);
  const { t, i18n } = useTranslation();

  const formik = useFormik({
    isInitialValid: false,
    initialValues: {
      v1: '',
      v2: '',
      v3: '',
      v4: '',
      v5: '',
      v6: '',
    },
    validationSchema: Yup.object().shape({
      v1: Yup.string().required(t('Required')),
      v2: Yup.string().required(t('Required')),
      v3: Yup.string().required(t('Required')),
      v4: Yup.string().required(t('Required')),
      v5: Yup.string().required(t('Required')),
      v6: Yup.string().required(t('Required')),
    }),
    onSubmit: async (values) => {
      await appCtx.fetchApi2('patch', '/api/v2/maintain/cfg', {
        rules: [
          {
            id: '48562',
            store_id: values.v1,
            store_name: values.v2,
            item: values.v3,
            period: Number(values.v4),
            dt_start: values.v5,
            note: values.v6,
          },
        ],
      });
      onOK();
    },
  });

  return (
    <div>
      <div className="text-white text-center py-1 bg-bar">{t('New')}</div>

      <div className="p-3">
        <F.Input
          label="店號"
          value={formik.values.v1}
          onValueChange={(value) => formik.setFieldValue('v1', value)}
        />
        <F.Input
          label="店名"
          value={formik.values.v2}
          onValueChange={(value) => formik.setFieldValue('v2', value)}
        />
        <F.Input
          label="保養品項"
          value={formik.values.v3}
          onValueChange={(value) => formik.setFieldValue('v3', value)}
        />
        <F.Input
          label="保養週期"
          value={formik.values.v4}
          onValueChange={(value) => formik.setFieldValue('v4', value)}
        />
        <F.Input
          label="起算日"
          value={formik.values.v5}
          onValueChange={(value) => formik.setFieldValue('v5', value)}
        />
        <F.Input
          label="備註"
          value={formik.values.v6}
          onValueChange={(value) => formik.setFieldValue('v6', value)}
        />

        <div className="mt-5 flex justify-end space-x-2">
          <button
            className="px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none"
            onClick={onCancel}
          >
            <div className="text-white text-base">{t('Cancel')}</div>
          </button>
          <button
            className={clsx(
              'px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none',
            )}
            onClick={() => formik.submitForm()}
          >
            <div className="text-white text-base">{t('Confirm')}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export const NewT2 = ({
  onOK,
  onCancel,
}: {
  onOK: () => void;
  onCancel: () => void;
}) => {
  const appCtx = React.useContext(AppContext);
  const { t, i18n } = useTranslation();

  const formik = useFormik({
    isInitialValid: false,
    initialValues: {
      v1: '',
      v2: '',
      v3: '',
    },
    validationSchema: Yup.object().shape({
      v1: Yup.string().required(t('Required')),
      v2: Yup.string().required(t('Required')),
      v3: Yup.string().required(t('Required')),
    }),
    onSubmit: async (values) => {
      onOK();
    },
  });

  return (
    <div>
      <div className="text-white text-center py-1 bg-bar">{t('New')}</div>

      <div className="p-3">
        <F.Input
          label="所屬維修記錄"
          value={formik.values.v1}
          onValueChange={(value) => formik.setFieldValue('v1', value)}
        />
        <F.Input
          label="圖片"
          value={formik.values.v2}
          onValueChange={(value) => formik.setFieldValue('v2', value)}
        />
        <F.Input
          label="說明"
          value={formik.values.v3}
          onValueChange={(value) => formik.setFieldValue('v3', value)}
        />

        <div className="mt-5 flex justify-end space-x-2">
          <button
            className="px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none"
            onClick={onCancel}
          >
            <div className="text-white text-base">{t('Cancel')}</div>
          </button>
          <button
            className={clsx(
              'px-5 py-1 rounded bg-button hover:bg-button-hover focus:outline-none',
            )}
            onClick={() => formik.submitForm()}
          >
            <div className="text-white text-base">{t('Confirm')}</div>
          </button>
        </div>
      </div>
    </div>
  );
};
